// Libs
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

// Components
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';

// Actions
import { feedback, selectAudioOutput } from 'REDUCERS/speakersSlice';

// Utils
import useTranslator from 'UTILS/hooks/useTranslator';
import { SPEAKERS_CHECK, RUNNING, YES, NO, RETRY } from 'UTILS/constants';
import { onTrackedClick } from 'UTILS/callbacks';
import translations from './locales.json';

const SpeakersDiagnostic = () => {
  const dispatch = useDispatch();
  const speakersCheck = useSelector(state => state.checks[SPEAKERS_CHECK]);
  const [translate] = useTranslator(translations);

  const handleSourceChange = ({ target }) => {
    dispatch(selectAudioOutput({ deviceId: target.value }));
  };

  const handleFeedback = (answer) => {
    onTrackedClick('speakers_answer', answer);
    dispatch(feedback({ answer }));
  };

  return (
    <>
      {speakersCheck.audioOutputList.length > 0 && (
        <Box className='speakersDiagnostic-labelWrapper'>
          <FormControl variant='filled' fullWidth disabled={speakersCheck.stage === RUNNING}>
            <InputLabel id='speakersDiagnostic-selectLabel'>{translate('device')}</InputLabel>
            <Select
              labelId='speakersDiagnostic-selectLabel'
              id='demo-simple-select-filled'
              value={speakersCheck.selectedAudioOutputId}
              onChange={handleSourceChange}
            >
              {speakersCheck.audioOutputList.map(source => (
                <MenuItem key={source.deviceId} value={source.deviceId}>
                  {source.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
      )}
      {speakersCheck.isPrompting &&
        <Paper className='speakersDiagnostic-prompt'>
          <Typography className='speakersDiagnostic-question'>{translate('haveYouHeardATone')}</Typography>
          <Box className='speakersDiagnostic-answerList'>
            <Box className='speakersDiagnostic-answer'>
              <Button
                onClick={() => handleFeedback(YES)}
                disabled={speakersCheck.isPlaying}
                variant='contained'
                color='primary'
              >
                {translate('yes')}
              </Button>
            </Box>
            <Box className='speakersDiagnostic-answer'>
              <Button
                onClick={() => handleFeedback(NO)}
                disabled={speakersCheck.isPlaying}
                variant='contained'
                color='primary'
              >
                {translate('no')}
              </Button>
            </Box>
            <Box className='speakersDiagnostic-answer'>
              <Button
                onClick={() => handleFeedback(RETRY)}
                disabled={speakersCheck.isPlaying}
                variant='contained'
                color='primary'
              >
                {translate('retry')}
              </Button>
            </Box>
          </Box>
        </Paper>
      }
    </>
  );
};

export default SpeakersDiagnostic;
